import PageHero from "../components/PageHero";
import InfoCard from "../components/InfoCard";
import SectionIntro from "../components/SectionIntro";
import Button from "../components/Button";
import { careerReasons, homeImages, mentorshipServices } from "../data/siteData";

export default function MentorshipPage() {
  return (
    <>
      <PageHero
        eyebrow="Mentorship & Career Development"
        title="Helping emerging professionals move from interest to opportunity."
        description="BrainTorch™ Bio mentorship and career development support learners and career transitioners pursuing STEM, clinical research, and healthcare careers."
        image={homeImages.workforce}
        compact
      />

      <section className="section shell">
        <SectionIntro
          eyebrow="What We Offer"
          title="Support across the career-readiness journey."
          text="Personalized mentorship and structured career-development support to help learners and professionals take the next step with confidence."
          align="center"
        />
        <div className="card-grid card-grid--four top-gap-lg">
          {mentorshipServices.map((service) => (
            <InfoCard key={service.title} title={service.title} text={service.description} icon={service.icon} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <SectionIntro
          eyebrow="Why Mentorship Matters"
          title="Why participants choose BrainTorch™ Bio."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {careerReasons.map((reason) => (
            <InfoCard key={reason.title} title={reason.title} text={reason.text} icon={reason.icon} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Looking for mentorship or career-development support?</h2>
            <p>Connect with the BrainTorch™ Bio team to learn how mentorship and career-development services can support your goals.</p>
          </div>
          <div className="button-row">
            <Button to="/contact#contact-connect" variant="teal">Get Started</Button>
          </div>
        </div>
      </section>
    </>
  );
}
